import React from "react";

import DisplayDocument from "./DisplayDocument";
import DownloadingDocument from "./DownloadingDocument";
import NoDocument from "./NoImage";
import ProcessingDocument from "./ProcessingDocument";
import UploaderForDocuments from "./UploaderForDocuments";
import UploadingDocument from "./UploadingDocument";

const DocumentUploader = (props: any) => {
    const components = [
        NoDocument,
        UploadingDocument,
        ProcessingDocument,
        DownloadingDocument,
        DisplayDocument
    ];

    return (
        <UploaderForDocuments
            id={props.id}
            handleChange={props.handleChange}
            document={props.document}
            type={props.type}
            components={components}
            {...props}
        />
    );
};

export default DocumentUploader;
